import { Deserializable } from '../../protocols/deserializable';
import { Address } from './address';
import * as moment from 'moment';

export class Spouse implements Deserializable {
  public id!: number;
  public firstName!: string;
  public middleName?: string;
  public lastName!: string;
  public socialInsuranceNumber!: string | null;
  public email!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public birthDate!: string;
  public address!: Address;
  // Not from API
  public formattedBirthDate!: string;
  public fullName!: string;

  onDeserialize(): void {
    this.fullName = `${this?.firstName} ${this?.lastName}`.trim();

    if (!!this.birthDate) {
      this.formattedBirthDate = moment(this.birthDate).format('MMM D, YYYY');
    }
    if (!!this.address) {
      this.address = window?.injector?.Deserialize?.instanceOf(Address, this.address);
    }
  }
}
